import { render } from "./footer.vue?vue&type=template&id=294517a4&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=294517a4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-294517a4"

export default script